export default __webpack_public_path__ + "static/media/welder.6516fcbc.jpg";